module.exports = __webpack_public_path__ + "img/2.f09e30c2.png";